// extracted by mini-css-extract-plugin
module.exports = {"heart":"ausz-pages-redirect-index-heart","appear":"ausz-pages-redirect-index-appear"};